/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { BaseService, HttpResponse } from '../../service/base';
import { EventDataResultDTO } from '../../service/event_service';
import { DiagnosticDTO } from '../fleet_tab/service';

//-------------------------------------------------------------------------------------------------
// DTO Objects
//-------------------------------------------------------------------------------------------------
export interface SweaperDTO {
    id: string;
    name: string;
    totalDistance: number;
    gradedDistance: number;
}

export interface SweapingDTO {
    assetId: string;
    latitude: number;
    longitude: number;
    timestamp: number;
    input1: boolean;
    input2: boolean;
    input3: boolean;
    input4: boolean;
}

export interface SweapingResultDTO {
    id: string;
    name: string;
    odometer: number;
}

export interface SweapingDashboardDTO {
    totalKm: number;
}

export interface SweapingEventDTO {
    assetId: string;
    eventId: string;
    geoJson: string;
    start: number;
    stop: number;
}

//-------------------------------------------------------------------------------------------------

/** Main service class that handles calls to the server and caches data
 * where it can.
 *
 */
export class SweaperService extends BaseService {
    /** Call to get the grader information for a time period
     *
     * @param startUTC Start time for query
     * @param endUTC End time for query
     * @returns Promise with the requested info.
     */
    async getSweepers(startUTC: number, endUTC: number): Promise<HttpResponse<DiagnosticDTO[]>> {
        const response = await this.get<DiagnosticDTO[]>(this.url + '/api/' + this.orgid + '/sweaper/info?start=' + startUTC + '&end=' + endUTC);
        return response;
    }

    async getDailyData(startUTC: number, endUTC: number) {
        const response = await this.get<EventDataResultDTO[]>(this.url + '/api/' + this.orgid + '/sweaper/dailydata?start=' + startUTC + '&end=' + endUTC);
        return response;
    }

    async getEvents(assetid: string, startUTC: number, endUTC: number): Promise<HttpResponse<SweapingEventDTO[]>> {
        const response = await this.get<SweapingEventDTO[]>(this.url + '/api/' + this.orgid + '/event/sweaper?assetid=' + assetid + '&start=' + startUTC + '&end=' + endUTC);
        return response;
    }
}
